export enum InventoryTypeEnum {
    Production = 'Production',
    Stock_Transfer = 'Stock_Transfer',
    Product_Conversion = 'Product_Conversion',
}